import { performance } from "perf_hooks";

export function InitializeGiftCertificatePage() {
    new GiftCertificatePage();
}

enum RecipientType {
    EmailToMe,
    EmailToRecipient,
    MailToRecipient
}

export class GiftCertificatePage {

    _amountOtherRadio: HTMLInputElement;
    _amountRadioList: HTMLInputElement[];
    _amountOtherSection: HTMLElement;
    _amountOtherTextbox: HTMLInputElement;
    _amountValue: HTMLInputElement;

    _recipientMailRadio: HTMLInputElement;
    _recipientRadioList: HTMLInputElement[];
    _recipientAddressSection: HTMLElement;
    _recipientEmailSection: HTMLElement;
    _recipientValue: HTMLInputElement;

    _emailLabel: HTMLElement;
    _confirmEmailLabel: HTMLElement;
    _mailDeliveryStateKey: string;
    _recipientEmailStateKey: string;
    constructor() {
        this._amountRadioList = Array.prototype.slice.call(document.querySelectorAll("[data-amount-radio]")) as HTMLInputElement[];
        this._amountOtherRadio = this._amountRadioList[this._amountRadioList.length - 1];
        this._amountOtherSection = document.querySelector("[data-amount-other]") as HTMLElement;
        this._amountOtherTextbox = document.querySelector("[data-amount-other-text]") as HTMLInputElement;
        this._amountValue = document.querySelector("[data-amount-value]") as HTMLInputElement;
        this._recipientRadioList = Array.prototype.slice.call(document.querySelectorAll("[data-recipient-radio]")) as HTMLInputElement[];
        this._recipientMailRadio = this._recipientRadioList[this._recipientRadioList.length - 1];
        this._recipientAddressSection = document.querySelector("[data-recipient-address]") as HTMLElement;
        this._recipientEmailSection = document.querySelector("[data-recipient-email]") as HTMLElement;
        this._recipientValue = document.querySelector("[data-recipient-value]") as HTMLInputElement;
        this._emailLabel = document.getElementById("lbl-email");
        this._confirmEmailLabel = document.getElementById("lbl-confirm-email");
        this._mailDeliveryStateKey = "MAIL_DELIVERY_STATE";
        this._recipientEmailStateKey = "RECIPIET_EMAIL_STATE";
        this.ClearStateOnReload();
        this.InitializeAmountEvents();
        this.InitializeRecipientEvents();
        this.InitializeRecipientState();
    }

    ClearStateOnReload = () => {
        if (window.performance) {
            if (window.performance.navigation.type == 1) {
                this.setDeliveryState(this._mailDeliveryStateKey, "false");
                this.setDeliveryState(this._recipientEmailStateKey, "false");
            }
        }
    }
    InitializeAmountEvents = () => {
        [].forEach.call(this._amountRadioList, radio => {
            radio.addEventListener("change", (e) => {
                // The 'other' option should display a textbox when clicked
                if (e.currentTarget === this._amountOtherRadio && (e.currentTarget as HTMLInputElement).checked === true) {
                    this._amountOtherSection.style.display = "block";
                    this._amountValue.value = this._amountOtherTextbox.value;
                }
                // Clear textbox when unselecting 'other'
                else {
                    this._amountOtherSection.style.display = "none";
                    this._amountOtherRadio.value = "";
                    this._amountOtherTextbox.value = "";
                    this._amountValue.value = e.currentTarget.value;
                }
            })
        });

        if (this._amountOtherRadio) {
            this._amountOtherTextbox.addEventListener("change", (e) => {
                this._amountValue.value = this._amountOtherTextbox.value;
            });
        }
    }

    InitializeRecipientState = () => {
        if (this.getDeliveryState(this._mailDeliveryStateKey).toLowerCase() == 'true' ) {
            this.DisplayMailToRecipientBlock();
        } else if (this.getDeliveryState(this._recipientEmailStateKey).toLowerCase() == 'true') {
            this.RecipientEmailAddress();
        } else {
            this.UserEmailAddress();
        }
    }


    getDeliveryState = (key:string) =>{
        let selectedOption = localStorage.getItem(key) || "false" ;
        return selectedOption;
    }

    setDeliveryState = (key: string, value: string) =>{
        localStorage.setItem(key, value);
    }

    DisplayMailToRecipientBlock = () => {
        this._recipientAddressSection.style.display = "block";
        this._recipientEmailSection.style.display = "none";
        this._recipientRadioList[2].checked = true;
        this._recipientValue.value = "2";
        this.setDeliveryState(this._mailDeliveryStateKey, "true");
        this.setDeliveryState(this._recipientEmailStateKey, "false");
    }

    RecipientEmailAddress = () => {
        this._recipientAddressSection.style.display = "none";
        this._recipientEmailSection.style.display = "block";
        this._emailLabel.textContent = "Recipient's Email Address";
        this._recipientRadioList[1].checked = true;
        this.setDeliveryState(this._mailDeliveryStateKey, "false");
        this.setDeliveryState(this._recipientEmailStateKey, "true");
        this._recipientValue.value = "1";

    }
    UserEmailAddress = () => {
        this._recipientAddressSection.style.display = "none";
        this._recipientEmailSection.style.display = "block";
        this._emailLabel.textContent = "Your Email Address";
        this._recipientRadioList[0].checked = true;
        this.setDeliveryState(this._mailDeliveryStateKey, "false");
        this.setDeliveryState(this._recipientEmailStateKey, "false");
        this._recipientValue.value = "0";
    }

    InitializeRecipientEvents = () => {
        [].forEach.call(this._recipientRadioList, recipient => {
            recipient.addEventListener('change', (e) => {
                // Toggle address section when they choose to deliver to address
                if ((e.currentTarget as HTMLInputElement).value == RecipientType.MailToRecipient.toString()) {
                    this.DisplayMailToRecipientBlock();
                }
                else if ((e.currentTarget as HTMLInputElement).value == RecipientType.EmailToRecipient.toString()) {
                    this.RecipientEmailAddress();
                }
                else {
                    this.UserEmailAddress();
                }

                this._recipientValue.value = (e.currentTarget as HTMLInputElement).value;
            });
        });
    }
}